import { $post, $download } from '@/api/request'
// 租金月度汇总 查询
export function queryExcelRentalStatistics (data) {
  return $post({
    url: '/excelRentalStatistics/query',
    data
  })
}
// 租金月度汇总 更新
export function updateExcelRentalStatistics (data) {
  return $post({
    url: '/excelRentalStatistics/update',
    data
  })
}
// Excel导出-楼宇出租房屋租金收缴统计表
export function exportRentalStatistics (data) {
  return $download({
    url: '/excelRentalStatistics/excelExport',
    data
  })
}
// EXCEL批量导入-楼宇出租房屋租金收缴统计表
export function importRentalStatistics (data) {
  return $post({
    url: '/excelRentalStatistics/excelImport',
    data
  })
}
// 租金单列统计 查询
export function queryExcelBuidingRental (data) {
  return $post({
    url: '/excelContractStatistics/query',
    data
  })
}
// 租金单列统计 编辑 更新
export function updateExcelBuidingRental (data) {
  return $post({
    url: '/excelBuidingRental/update',
    data
  })
}
// EXCEL批量导入-楼宇出租房屋租金收缴统计表
export function importExcelBuidingRental (data) {
  return $post({
    url: '/excelBuidingRental/excelImport',
    data
  })
}
// Excel导出-楼宇出租房屋租金收缴统计表
export function exportExcelBuidingRental (data) {
  return $download({
    url: '/excelBuidingRental/excelExport',
    data
  })
}
// Excel导出-租金单例统计  确认是这个接口
export function exportContractStatistics (data) {
  return $download({
    url: '/excelContractStatistics/excelExport',
    data
  })
}
// 待租房屋明细 查询
export function queryExcelAvailableBuilding (data) {
  return $post({
    url: '/excelBuidingRental/query',
    data
  })
}
// 待租房屋明细 更新
export function updateExcelAvailableBuilding (data) {
  return $post({
    url: '/excelAvailableBuilding/update',
    data
  })
}
// EXCEL批量导入-待租房屋明细表
export function importExcelAvailableBuilding (data) {
  return $post({
    url: '/excelAvailableBuilding/excelImport',
    data
  })
}
// Excel导出-待租房屋明细表
export function exportExcelAvailableBuilding (data) {
  return $download({
    url: '/excelAvailableBuilding/excelExport',
    data
  })
}
// 待租房屋面积
export function forRentArea (data) {
  return $post({
    url: '/excelBuidingRental/queryRentableArea',
    data
  })
}
// 租金月度汇总 新接口
// 查询月度表
export function queryExcelMonthBuilding (data) {
  return $post({
    url: '/excelMonthBuilding/query',
    data
  })
}
// 更新月度表
export function updateExcelMonthBuilding (data) {
  return $post({
    url: '/excelMonthBuilding/update',
    data
  })
}
// EXCEL批量导入-统计报表-租金月度汇总[楼宇维度]
export function importExcelMonthBuilding (data) {
  return $post({
    url: '/excelMonthBuilding/excelImport',
    data
  })
}
// Excel导出-统计报表-租金月度汇总[楼宇维度]
export function exportExcelMonthBuilding (data) {
  return $download({
    url: '/excelMonthBuilding/excelExport',
    data
  })
}
// EXCEL批量导入-统计报表-租金月度汇总[总和维度]
export function importExcelMonthSummary (data) {
  return $post({
    url: '/excelMonthSummary/excelImport',
    data
  })
}
// Excel导出-统计报表-租金月度汇总[总和维度]
export function exportExcelMonthSummary (data) {
  return $download({
    url: '/excelMonthSummary/excelExport',
    data
  })
}
// 查询累计信息
export function queryExcelMonthSummary (data) {
  return $post({
    url: '/excelMonthSummary/query',
    data
  })
}
// 更新累计情况表
export function updateExcelMonthSummary (data) {
  return $post({
    url: '/excelMonthSummary/update',
    data
  })
}
